/* unplugin-vue-components disabled */import script from "./MediaTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaTable.vue?vue&type=script&setup=true&lang=js"

import "./MediaTable.vue?vue&type=style&index=0&id=6a7d6758&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7d6758"]])

export default __exports__